<template>
  <router-view />
</template>

<script>
import { auth } from "@/firebase.js";
import { mapActions } from "vuex";
import { decodeJwtPayload } from "./helpers/decodeJwtPayload";

export default {
  name: "App",
  methods: {
    ...mapActions(["ActualizarUsuario"])
  },
  created() {
    auth.onAuthStateChanged(async user => {
      if (user) {
        const token = await user.getIdToken();
        const payload = decodeJwtPayload(token);
        const isParticipant = payload.role === "participant";
        if (
          (this.$route.name == "Menu" || this.$route.name == "Login") &&
          !isParticipant
        ) {
          this.$router.push({ name: "Dashboard" });
        } else {
          this.$router.push({ name: "Chat" });
        }
      } else {
        if (this.$route.name != "Login") {
          this.$router.push({ name: "Login" });
        }
      }
      this.ActualizarUsuario();
    });
  }
};
</script>

<style>
.bg-facpya {
  background-color: #004a8f !important;
}
.btn-facpya {
  background-color: #384243 !important;
  color: white !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue